// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"867":"b8c53be3","1378":"abe0b499","2717":"d720a3be","4555":"7e2bda07","5576":"b6b39c66","5770":"a8e04ecd","6264":"33f50ac7","8515":"4e0f7e65"}[chunkId] + ".chunk.css";
};